define([], function() {
  //Empty controller
});
